import React from 'react'

const iconType = {
  filled: 'material-icons',
  outlined: 'material-icons-outlined',
  round: 'material-icons-round',
  sharp: 'material-icons-sharp',
  twoTone: 'material-icons-two-tone'
}

/**
 *
 * @param {Object} params
 * @param {string} params.name
 * @param {string} params.type
 * @returns
 */
const Icon = ({ name, type = 'filled', ...props }) => {
  if (!name) throw new Error('iconName is required')
  return (
    <span className={`icon ${iconType[type]}`} {...props}>
      {name}
    </span>
  )
}

export default Icon
